"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var SplashScreenComponent_1 = require("./SplashScreenComponent");
var StyleComponents_1 = require("./StyleComponents");
var LoadingScreenComponent = /** @class */ (function (_super) {
    __extends(LoadingScreenComponent, _super);
    function LoadingScreenComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingScreenComponent.prototype.render = function () {
        return (React.createElement(SplashScreenComponent_1.default, null,
            React.createElement(StyleComponents_1.CenterComponent, { width: "100%", height: "100%" },
                React.createElement(StyleComponents_1.Flexbox, null,
                    React.createElement(reactstrap_1.Media, { style: {
                            maxWidth: '80%'
                        }, object: true, src: 'image/logo_cieniowane_pelne_male.png', alt: "Brak logo" }),
                    React.createElement("br", null),
                    React.createElement(reactstrap_1.Spinner, null),
                    React.createElement("br", null),
                    React.createElement("p", null, "Wczytywanie")))));
    };
    return LoadingScreenComponent;
}(React.Component));
exports.default = LoadingScreenComponent;
//# sourceMappingURL=LoadScreenComponent.js.map